import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { SingleUpiResponse } from 'src/app/models/services/upi/upi-service-response.model';
import { Upi } from 'src/app/models/upi.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class UpiService {
  constructor(private http: HttpClient) {}

  getUpiInfoByAVS(avs: string): Observable<Upi> {
    return this.http
      .get<SingleUpiResponse>(environment.apiUrl + '/upi/info?avs=' + avs, {
        headers: httpOptions.headers,
      })
      .pipe(
        map(response => {
          return response.upiModel;
        })
      );
  }

  /**
   * @description
   * Retrieves user UPI infos based on AVS, name and dateOfBirth.
   * The check is done server side to prevent data leaks.
   *
   * @param avs User AVS number.
   * @param officialName User offical name.
   * @param dateOfBirth User date of birth `yyyy-MM-dd`.
   * @returns Null or the matching user.
   */
  getUpiOnMatch(
    avs: string,
    officialName: string,
    dateOfBirth: string
  ): Observable<Upi | null> {
    return this.http
      .post<SingleUpiResponse>(
        environment.apiUrl + '/upi',
        {
          Avs: avs,
          OfficialLastName: officialName,
          DateOfBirth: dateOfBirth,
        },
        httpOptions
      )
      .pipe(
        map(response => {
          return response.upiModel;
        })
      );
  }
}
